import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { postRefund, postRefundAuth } from 'services/RefundService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { RefundPayload } from 'types/refund'

export const useRefundMutation = () => {
  return useMutation({
    mutationFn: postRefund,
    onError: (error: BaseErrorResponse, data: RefundPayload) => {
      if (error?.status !== 428) {
        logSentryError('Error: useRefundMutation', error, data)
      }
    },
  })
}

export const useRefundAuthMutation = () => {
  return useMutation({
    mutationFn: postRefundAuth,
    onError: (error: BaseErrorResponse, data) => {
      if (error?.status !== 403) {
        logSentryError('Error: useRefundAuthMutation', error, data)
      }
    },
  })
}
